import React, { createContext, useContext, useMemo } from 'react';
import useTasksListener from './useTasksListener';

//------ Context -------
//
const TaskListenerContext = createContext();

//------ Provider ------
export const TaskListenerContextProvider = ({children}) => {
  const {tasksChanged} = useTasksListener();

  const memoizedValue = useMemo(()=>({
    tasksChanged
  }), [tasksChanged]);

  return (<TaskListenerContext.Provider value={memoizedValue}>{children}</TaskListenerContext.Provider>);
};

export function useTaskListenerContext() {
  return useContext(TaskListenerContext);
}